import { AZURE_RESOURCES } from '@services/requests/requestResources';
import { makeRequest } from '../makeRequest';

export const getAzureResourceData = () =>
  makeRequest('GET', `${AZURE_RESOURCES}/get-cname-info`);

export const getCustomDomain = () =>
  makeRequest('GET', `${AZURE_RESOURCES}/get-custom-domain`);

export const validateDomain = domain =>
  makeRequest('GET', `${AZURE_RESOURCES}/validate-domain?domain=${domain}`);

export const assignDomain = domain =>
  makeRequest('GET', `${AZURE_RESOURCES}/assign-domain?domain=${domain}`);

export const deleteCustomDomain = () =>
  makeRequest('DELETE', `${AZURE_RESOURCES}/remove-domain`);

export const bindSslCertificate = domain =>
  makeRequest(
    'GET',
    `${AZURE_RESOURCES}/bind-ssl-certificate?domain=${domain}`,
  );

export const createSslCertificate = domain =>
  makeRequest(
    'GET',
    `${AZURE_RESOURCES}/generate-ssl-certificate?domain=${domain}`,
  );
